export const UserActivityStatus  = {
    ACTIVE:"ACTIVE",
    BLOCKED:"BLOCKED"
}